export default "__VITE_ASSET__BtZRwGQy__"